import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getCustomerRequirementFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.customer_requirement}`, { params: req });
    return response;
}